import React from 'react';

const WhatsAppButton = () => {
	const phoneNumber = "97167412344"; // full number without spaces and +
	const whatsappUrl = `https://wa.me/${phoneNumber}`;

	return (
		<>
			<style>{`
				.whatsapp-float {
					position: fixed;
					width: 60px;
					height: 60px;
					bottom: 20px;
					right: 75px;
					// background-color: #25d366;
					color: #FFF;
					border-radius: 50px;
					text-align: center;
					font-size: 30px;
					// box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
					z-index: 1000;
					transition: all 0.3s ease;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					text-decoration: none;
				}
				.whatsapp-float:hover {
					background-color: #20ba5a;
					transform: scale(1.1);
					box-shadow: 2px 2px 15px rgba(37, 211, 102, 0.5);
				}
				.whatsapp-float:active {
					transform: scale(0.95);
				}
				.whatsapp-float img {
					width: 60px;
					height: 90px;
					object-fit: contain;
				}
				@media (max-width: 768px) {
					.whatsapp-float {
						width: 55px;
						height: 55px;
						bottom: 15px;
						right: 15px;
					}
					.whatsapp-float img {
						           margin-top: 15px;
        width: 50px;
        height: 54px;
					}
				}
			`}</style>
			<a
				href={whatsappUrl}
				target="_blank"
				rel="noopener noreferrer"
				className="whatsapp-float"
				aria-label="Contact us on WhatsApp"
			>
				<img 
					src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
					alt="WhatsApp" 
				/>
			</a>
		</>
	);
};

export default WhatsAppButton;




